import * as next from 'next'

import * as hooks from '@owl-nest/hooks'

import * as core from '@boutique/services'
import * as entity from '@boutique/entities'
import { type ProductListProps, HITS_PER_PRODUCT_PAGE } from '@boutique/product'

export { ProductList as default } from '@boutique/product'

export async function getServerSideProps(
  context: next.GetServerSidePropsContext,
): Promise<next.GetServerSidePropsResult<ProductListProps>> {
  const query = entity.search.product.fromParsedUrlQuery(context.query)
  const fullQuery = { ...query, hitsPerPage: HITS_PER_PRODUCT_PAGE }
  const preFetchedData = await core.search.product.searchProduct(fullQuery)

  return {
    props: {
      productCache: {
        [core.search.product.id(fullQuery)]: {
          status: hooks.QueryStatus.SUCCESS,
          data: preFetchedData,
        },
      },
    },
  }
}
